<script setup lang="ts">
    import { computed, type HTMLAttributes } from 'vue';
    import { Checkbox } from '@/components/ui/checkbox';
    import { Label } from '@/components/ui/label';
    import { cn } from '@/lib/utils';
    import { useVModel } from '@vueuse/core';
    import { useI18n } from 'vue-i18n';

    const { t } = useI18n();

    const props = defineProps<{
        defaultValue?: boolean;
        modelValue?: boolean;
        id: string;
        label?: string;
        class?: HTMLAttributes['class'];
    }>();

    const emits = defineEmits<{
        (e: 'update:modelValue', payload: boolean): void;
    }>();

    const modelValue = useVModel(props, 'modelValue', emits, {
        passive: true,
        defaultValue: props.defaultValue,
    });

    const label = computed(() => {
        return props.label ? t(props.label) : '';
    });
</script>

<template>
    <Label
        :for="id"
        :class="cn('flex cursor-pointer items-center justify-self-start', props.class)"
    >
        <Checkbox
            v-model="modelValue"
            data-slot="checkbox"
            :id="id"
        />
        <slot>
            <span>{{ label }}</span>
        </slot>
    </Label>
</template>
